// extracted by mini-css-extract-plugin
export var boxItems = "_6f-1";
export var button = "_6f-5";
export var filterGroupBox = "_6f-0";
export var icon = "_6f-2";
export var iconSecondary = "_6f-4";
export var iconWrapper = "_6f-3";